module.exports = __webpack_public_path__ + "static/media/no_collection.191e5e68.png";